const data = require('../SaasModern/index.json');
import VectorServiceClient from '../../assets/image/logo/icon/vector';
import playCircle from '../../assets/image/logo/icon/playCircle';
import { StructuredDataIcon } from '../../assets/image/logo/icon/StructuredDataIcon';
import { HRAssistantIcon } from '../../assets/image/logo/icon/HRAssistantIcon';
import { InternalSupportIcon } from '../../assets/image/logo/icon/InternalSupportIcon';
import { CompetitorMonitoringIcon } from 'common/assets/image/logo/icon/CompetitorMonitoringIcon';
import { ContentWritingIcon } from 'common/assets/image/logo/icon/ContentWritingIcon';
import { TechnologyIntelligenceIcon } from 'common/assets/image/logo/icon/TechnologyIntelligenceIcon';
import ChartPieSlice from 'common/assets/image/logo/icon/ChartPieSlice';
import AihubIcon from 'common/assets/image/logo/icon/AihubIcon';
import CompanyIcon from 'common/assets/image/logo/icon/CompanyIcon';
import SecurityIcon from 'common/assets/image/logo/icon/SecurityIcon';
import AiagentIcoon from 'common/assets/image/logo/icon/AiagentIcoon';

export const MENU_ITEMS = [
  // {
  //   label: 'Widget',
  //   path: '../../chatbot-widget',
  //   offset: '0',
  //   intl: 'Widget',
  //   location: '/chatbot-widget',
  // },
  // {
  //   label: 'About',
  //   path: '../../about',
  //   location: '/about',
  //   offset: '0',
  //   intl: { 'en-us': 'About', 'fr-fr': 'À propos' },
  // },
  // {
  //   label: 'Products',
  //   path: '../../product',
  //   location: '/product',
  //   offset: '0',
  //   intl: { 'en-us': 'Product', 'fr-fr': 'Produits' },
  //   subMenu: [
  //     {
  //       label: 'AI Agent',
  //       path: '',
  //       icon: '/icons/ai-agent.svg',
  //       intl: { 'en-us': 'AI Agent', 'fr-fr': 'Agent IA' },
  //     },
  //     {
  //       label: 'AI Hub',
  //       path: '',
  //       icon: '/icons/ai-hub.svg',
  //       intl: { 'en-us': 'AI Hub', 'fr-fr': 'Hub IA' },
  //     },
  //     {
  //       label: 'Extension',
  //       path: '',
  //       icon: '/icons/extension.svg',
  //       intl: { 'en-us': 'Extension', 'fr-fr': 'Extension' },
  //     },
  //     {
  //       label: 'AI Chatbot',
  //       path: '',
  //       icon: '/icons/ai-chatbot.svg',
  //       intl: { 'en-us': 'AI Chatbot', 'fr-fr': 'Chatbot IA' },
  //     },
  //     {
  //       label: 'AI Acculturation',
  //       path: '',
  //       icon: '/icons/ai-acculturation.svg',
  //       intl: { 'en-us': 'AI Acculturation', 'fr-fr': 'Acculturation IA' },
  //     },
  //     {
  //       label: 'Integrations',
  //       path: '',
  //       icon: '/icons/integrations.svg',
  //       intl: { 'en-us': 'Integrations', 'fr-fr': 'Intégrations' },
  //     },
  //   ],
  // },
  // {
  //   label: 'Solutions',
  //   path: '',
  //   location: '/solution',
  //   offset: '0',
  //   intl: { 'en-us': 'Solutions', 'fr-fr': 'Solutions' },
  // },
  // {
  //   label: 'Resources',
  //   path: '',
  //   location: '/resource',
  //   offset: '0',
  //   intl: { 'en-us': 'Resources', 'fr-fr': 'Ressources' },
  // },
  // {
  //   label: 'About',
  //   path: '',
  //   location: '/about',
  //   offset: '0',
  //   intl: { 'en-us': 'About', 'fr-fr': 'A propos' },
  // },
  {
    label: 'Solutions',
    path: '/solutions',
    location: '/solutions',
    offset: '0',
    intl: { 'en-us': 'Solutions', 'fr-fr': 'Solutions' },
    subMenu: [
      {
        label: 'AI Agent',
        path: '/ai-agent',
        icon: AiagentIcoon,
        intl: {
          'en-us': 'AI Agent',
          'fr-fr': 'Agent IA',
        },
      },
      {
        label: 'AI Hub',
        path: '/ai-hub',
        icon: AihubIcon,
        intl: {
          'en-us': 'AI Hub',
          'fr-fr': 'Hub IA',
        },
      },
      {
        label: 'Security',
        path: '/security',
         icon: SecurityIcon,
        intl: {
          'en-us': 'Security',
          'fr-fr': 'Sécurité',
        },
      },
    {
    label: 'Company',
    path: '/company',
    icon:CompanyIcon,
    location: '/company',
    offset: '0',
    intl: { 'en-us': 'Company', 'fr-fr': 'Entreprise' },
  },
    ],
  },

  // {
  //   label: 'Company',
  //   path: '../../company',
  //   location: '/company',
  //   offset: '0',
  //   intl: { 'en-us': 'Company', 'fr-fr': 'Entreprise' },
  // },
  {
    label: 'Blog',
    path: '../../blog',
    location: '/blog',
    offset: '0',
    intl: { 'en-us': 'Blog', 'fr-fr': 'Blog' },
    // subMenu: [
    //   {
    //     label: 'Blog',
    //     path: '../../blog',
    //     location: '/blog',
    //     intl: { 'en-us': 'Blog', 'fr-fr': 'Blog' },
    //     icon: <Blog/>,
    //   },
    //   {
    //     label: 'Help center',
    //     path: 'https://docs.swiftask.ai/',
    //     location: 'external',
    //     intl: { 'en-us': 'Help center', 'fr-fr': 'Centre d’aide' },
    //     icon: <Info/>,
    //   },
    // ],
  },
  
  {
    label: 'Use cases',
    path: '/use-case',
    location: '/use-cases',
    offset: '0',
    intl: { 'en-us': 'Use cases', 'fr-fr': "Cas d'utilisation" },
    subMenu: [
      {
        label: 'Competitor monitoring',
        path: '/use-case',
        icon: CompetitorMonitoringIcon,
        intl: {
          'en-us': 'Competitor monitoring',
          'fr-fr': 'Veille concurrentielle',
        },
      },
      {
        label: 'Content writing',
        path: '/use-case/use-case-content-writing',
        icon: ContentWritingIcon,
        intl: { 'en-us': 'Content writing', 'fr-fr': 'Rédaction de contenu' },
      },
      {
        label: 'Customer service',
        path: '/use-case/use-case-client',
        icon: VectorServiceClient,
        intl: { 'en-us': 'Customer service', 'fr-fr': 'Service client' },
      },
      {
        label: 'Data analysis and reporting',
        path: '/use-case/use-case-analyse-data',
        icon: ChartPieSlice,
        intl: {
          'en-us': 'Data analysis and reporting',
          'fr-fr': 'Analyse de données et reporting',
        },
      },
      {
        label: 'HR agent',
        path: '/use-case/use-case-rh-agent',
        icon: HRAssistantIcon,
        intl: { 'en-us': 'HR assistant', 'fr-fr': 'Assistant RH' },
      },
      {
        label: 'Internal support',
        path: '/use-case/use-case-internal-support',
        icon: InternalSupportIcon,
        intl: { 'en-us': 'Internal support', 'fr-fr': 'Support interne' },
      },
      {
        label: 'SEO & social media',
        path: '/use-case/use-case-seo-social-media',
        icon: playCircle,
        intl: {
          'en-us': 'SEO and social media',
          'fr-fr': 'SEO et Social Media',
        },
      },
      {
        label: 'Business intelligence',
        path: '/use-case/use-case-business-intelligence',
        icon: StructuredDataIcon,
        intl: { 'en-us': 'Business intelligence', 'fr-fr': "Intelligence d'affaires" },
      },
      {
        label: 'Tech monitoring',
        path: '/use-case/use-case-technology-monitoring',
        icon: TechnologyIntelligenceIcon,
        intl: {
          'en-us': 'Tech monitoring',
          'fr-fr': 'Veille technologique',
        },
      },
    ],
  },
  {
    label: 'Pricing',
    path: '../../pricing?tab=TEAM',
    location: '/pricing',
    offset: '0',
    intl: { 'en-us': 'Pricing', 'fr-fr': 'Tarification' },
  },
  // {
  //   label: 'Blog',
  //   path: '../../blog',
  //   location: '/blog',
  //   offset: '0',
  //   intl: { 'en-us': 'Blog', 'fr-fr': 'Blog' },
  // },
];

export const FOOTER_WIDGET = [
  {
    title: { 'en-us': 'LEGAL & SECURITY', 'fr-fr': 'LÉGAL & SÉCURITÉ' },
    // menuItems: [
    //   {
    //     url: '/swiftask-extension',
    //     text: { 'en-us': 'Swiftask extension', 'fr-fr': 'Extension Swiftask' },
    //     blank: false,
    //   },
    //   {
    //     url: '/acculturation',
    //     text: { 'en-us': 'AI Acculturation', 'fr-fr': 'Acculturation IA' },
    //     blank: false,
    //   },
    //   {
    //     url: '/integrations',
    //     text: { 'en-us': 'Integrations', 'fr-fr': 'Intégrations' },
    //     blank: false,
    //   },
    // ],
    menuItems: [
      // {
      //   url: '/about-us',
      //   text: { 'en-us': 'About us', 'fr-fr': 'À propos de nous' },
      //   blank: false,
      // },
     {
        url: '/about-us',
        text: {
          'en-us': 'About us',
          'fr-fr': 'À propos de nous',
        },
        blank: false,
      },
      
      {
        url: 'https://www.swiftask.ai/privacy.html',
        text: {
          'en-us': 'Privacy policy',
          'fr-fr': 'Politique de confidentialité',
        },
        blank: false,
      },
      {
        url: 'https://www.swiftask.ai/tos.html',
        text: {
          'en-us': 'General terms and conditions',
          'fr-fr': 'Conditions générales',
        },
        blank: false,
      },
      {
        url: '/security',
        text: {
          'en-us': 'Security',
          'fr-fr': 'Sécurité',
        },
        blank: false,
      },
    ],
  },
  {
    title: { 'en-us': 'SOLUTION', 'fr-fr': 'SOLUTIONS' },
    menuItems: [
      {
        url: '/ai-agent',
        text: { 'en-us': 'AI Agent', 'fr-fr': 'AI Agent' },
        blank: false,
      },
     
      {
        url: '/ai-hub',
        text: { 'en-us': 'AI Hub', 'fr-fr': 'AI Hub' },
        blank: false,
      },
       {
        url: '/setup-chrome',
        text: { 'en-us': 'Swiftask extension', 'fr-fr': 'Extension Swiftask' },
        blank: false,
      },
       {
        url: '/acculturation',
        text: { 'en-us': 'AI Acculturation', 'fr-fr': 'Acculturation IA' },
        blank: false,
      },
     
      // {
      //   url: '/ai-hub',
      //   text: { 'en-us': 'AI Hub', 'fr-fr': 'AI Hub' },
      //   blank: false,
      // },
      // {
      //   url: '/ai-widget',
      //   text: { 'en-us': 'AI Widget', 'fr-fr': 'AI Widget' },
      //   blank: false,
      // },
      // {
      //   url: '/integrations',
      //   text: { 'en-us': 'Integrations', 'fr-fr': 'Intégrations' },
      //   blank: false,
      // },
    ],
  },
  // {
  //   title: { 'en-us': 'Use cases', 'fr-fr': "Cas d'utilisation" },
  //   menuItems: [
  // {
  //   url: '/customer-service',
  //   text: { 'en-us': 'Customer service', 'fr-fr': 'Service client' },
  //   blank: false,
  // },
  // {
  //   url: '/seo-social-media',
  //   text: {
  //     'en-us': 'SEO & social media',
  //     'fr-fr': 'SEO & médias sociaux',
  //   },
  //   blank: false,
  // },
  // {
  //   url: '/data-analysis',
  //   text: {
  //     'en-us': 'Data analysing and reporting',
  //     'fr-fr': 'Analyse de données et rapports',
  //   },
  //   blank: false,
  // },
  // {
  //   url: '/internal-support',
  //   text: { 'en-us': 'Internal support', 'fr-fr': 'Support interne' },
  //   blank: false,
  // },
  //   ],
  // },
  {
    title: { 'en-us': 'RESOURCES', 'fr-fr': 'RESSOURCES' },
    menuItems: [
      {
        url: '/blog',
        text: { 'en-us': 'Blog', 'fr-fr': 'Blog' },
        blank: false,
      },
  
      {
        url: 'https://docs.swiftask.ai/',
        text: { 'en-us': 'Helpcenter & FAQ', 'fr-fr': "Centre d'aide & FAQ" },
        blank: false,
      },
        {
        url: 'https://docs.swiftask.ai/changelog',
        text: { 'en-us': 'Changelog', 'fr-fr': 'Changelog' },
        blank: false,
      },
      // {
      //   url: '/webinars-events',
      //   text: {
      //     'en-us': 'Webinars & events',
      //     'fr-fr': 'Webinaires & événements',
      //   },
      //   blank: false,
      // },
    ],
  },
];

export const PROCESS_ITEMS = data.PROCESS_ITEMS;
export const MONTHLY_PRICING_TABLE = data.MONTHLY_PRICING_TABLE;
export const YEARLY_PRICING_TABLE = data.YEARLY_PRICING_TABLE;
export const FAQ_DATA = data.FAQ_DATA;
export const FEATURES = data.FEATURES;
export const TESTIMONIALS = data.TESTIMONIALS;
